import { useEffect, useState } from 'react';
import { NoImage } from '../assets/images';
import { getIntroByMode } from '../services/GroupService';

export default function useImageHeader(mode: number, groupId: string) {
  const [imageHeader, setImageHeader] = useState('');
  const getGroup = async () => {
    const res = await getIntroByMode(mode, groupId);
    if (res) {
      res?.length ? setImageHeader(res[0]?.header_url) : setImageHeader(NoImage);
    }
  };

  useEffect(() => {
    getGroup();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupId]);
  return { imageHeader };
}
